/**
 * Temporary placeholder until real tables / filters are wired to the API.
 */
export default function QcPlaceholderCard({ heading, body }) {
  return (
    <div className="mx-auto w-full max-w-[720px] text-center">
      <h3 className="mb-3 font-semibold text-gray-800 text-theme-lg dark:text-white/90 sm:text-xl md:text-2xl">
        {heading}
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 sm:text-base">
        {body}
      </p>
    </div>
  );
}
